var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "text-center" }, [
      _vm._v(_vm._s(_vm.$t("Yhteenveto")))
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "font-weight-bold text-center" }, [
      _vm._v(
        "Kiitos että valitsit Pohjois-Karjalan Sähkön! Tarkista alla olevat sopimuksesi tiedot ja vahvista sopimus."
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("h3", { staticClass: "card-title confirmation-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("Asiakastiedot")))
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-lg": "3",
                        "label-align-md": "right"
                      }
                    },
                    [
                      _c("label", { staticClass: "pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Nimi")))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.customerName))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isAcceptingOffer
                    ? _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            "label-cols-sm": "12",
                            "label-cols-lg": "3",
                            "label-align-md": "right"
                          }
                        },
                        [
                          _vm.contract.CustomerType == 1
                            ? _c("label", { staticClass: "pt-0" }, [
                                _vm._v(_vm._s(_vm.$t("Henkilötunnus")))
                              ])
                            : _c("label", { staticClass: "pt-0" }, [
                                _vm._v(_vm._s(_vm.$t("Y-tunnus")))
                              ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.customerIdentifier))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAcceptingOffer
                    ? _c(
                        "div",
                        [
                          _vm.contract.CustomerType == 1
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    "label-cols-sm": "12",
                                    "label-cols-lg": "3",
                                    "label-align-md": "right"
                                  }
                                },
                                [
                                  _c("label", { staticClass: "pt-0" }, [
                                    _vm._v(_vm._s(_vm.$t("Henkilötunnus")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "validated-form-group",
                                    {
                                      attrs: {
                                        "validation-id": "Pin",
                                        "validation-errors":
                                          _vm.validationErrors
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "new-contract-value",
                                            rawName: "v-new-contract-value"
                                          }
                                        ],
                                        attrs: {
                                          type: "text",
                                          name: "Pin",
                                          value: _vm.customer.Pin
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contract.CustomerType == 2
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    "label-cols-sm": "12",
                                    "label-cols-md": "12",
                                    "label-cols-lg": "3",
                                    "label-align-md": "right"
                                  }
                                },
                                [
                                  _c("label", { staticClass: "pt-0" }, [
                                    _vm._v(_vm._s(_vm.$t("Y-tunnus")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "validated-form-group",
                                    {
                                      attrs: {
                                        "validation-id": "BusinessId",
                                        "validation-errors":
                                          _vm.validationErrors
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "new-contract-value",
                                            rawName: "v-new-contract-value"
                                          }
                                        ],
                                        attrs: {
                                          type: "text",
                                          name: "BusinessId",
                                          maxlength: "20",
                                          value: _vm.company.BusinessId
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-0",
                              attrs: {
                                "label-cols-sm": "12",
                                "label-cols-lg": "3",
                                "label-align-md": "right"
                              }
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "pt-0",
                                  attrs: { for: "confirmation_phone_field" }
                                },
                                [_vm._v("Puhelinnumero")]
                              ),
                              _vm._v(" "),
                              _c(
                                "validated-form-group",
                                {
                                  attrs: {
                                    "validation-id": "Phone",
                                    "validation-errors": _vm.validationErrors
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "new-contract-value",
                                        rawName: "v-new-contract-value"
                                      }
                                    ],
                                    attrs: {
                                      id: "confirmation_phone_field",
                                      type: "text",
                                      name: "Phone",
                                      value: _vm.customer.Phone
                                        ? _vm.customer.Phone
                                        : "+358"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.customerEmail
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    "label-cols-sm": "12",
                                    "label-cols-lg": "3",
                                    "label-align-md": "right"
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "pt-0",
                                      attrs: { for: "confirmation_email_field" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("Sähköpostiosoite")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "validated-form-group",
                                    {
                                      attrs: {
                                        "validation-id": "Email",
                                        "validation-errors":
                                          _vm.validationErrors
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "new-contract-value",
                                            rawName: "v-new-contract-value"
                                          }
                                        ],
                                        attrs: {
                                          id: "confirmation_email_field",
                                          type: "email",
                                          name: "Email",
                                          value: _vm.customer.Email
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _vm.customerPhone
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    "label-cols-sm": "12",
                                    "label-cols-lg": "3",
                                    "label-align-md": "right"
                                  }
                                },
                                [
                                  _c("label", { staticClass: "pt-0" }, [
                                    _vm._v(_vm._s(_vm.$t("Puhelinnumero")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v(_vm._s(_vm.customerPhone))]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.customerEmail
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    "label-cols-sm": "12",
                                    "label-cols-lg": "3",
                                    "label-align-md": "right"
                                  }
                                },
                                [
                                  _c("label", { staticClass: "pt-0" }, [
                                    _vm._v(_vm._s(_vm.$t("Sähköpostiosoite")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v(_vm._s(_vm.customerEmail))]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.contract.CustomerType == 2
                    ? _c(
                        "div",
                        _vm._l(_vm.contactPersons, function(
                          contactPerson,
                          index
                        ) {
                          return _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    "label-cols-sm": "12",
                                    "label-cols-md": "12",
                                    "label-cols-lg": "3",
                                    "label-align-md": "right"
                                  }
                                },
                                [
                                  _c("label", { staticClass: "pt-0" }, [
                                    _vm._v(_vm._s(_vm.$t("Yhteyshenkilö")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(contactPerson.FirstName) +
                                          " " +
                                          _vm._s(contactPerson.LastName)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  contactPerson.Phone !== null &&
                                  contactPerson.Phone !== ""
                                    ? _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v(_vm._s(contactPerson.Phone))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  contactPerson.Email !== null &&
                                  contactPerson.Email !== ""
                                    ? _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v(_vm._s(contactPerson.Email))]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-lg": "1",
                        "label-align-md": "right"
                      }
                    },
                    [
                      _c("label", { staticClass: "pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Asiakkaan osoite")))
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "font-weight-bold" }, [
                        _vm.CONameString != ""
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.CONameString)),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.customerAddressString))
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm._l(_vm.contractPartners, function(contractPartner, index) {
                return [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6", lg: "4" } },
                    [
                      _c("contract-partner-card", {
                        attrs: {
                          title: _vm.$t("Sopimuskumppani ") + (index + 1),
                          "contact-person": contractPartner,
                          editable: false
                        }
                      })
                    ],
                    1
                  )
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h3", { staticClass: "card-title confirmation-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("Tuotevalinta")))
          ]),
          _vm._v(" "),
          _c("form-group-static", [_c("product-selection-display")], 1),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h3", { staticClass: "card-title confirmation-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("Käyttöpaikan tiedot")))
          ]),
          _vm._v(" "),
          _c(
            "form-group-static",
            [_c("metering-point-information-display")],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h3", { staticClass: "card-title confirmation-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("Sopimustiedot")))
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "3"
                      }
                    },
                    [
                      _c("label", { staticClass: "pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Maksutapana on laskutus.")))
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "3"
                      }
                    },
                    [
                      _c("label", { staticClass: "pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Laskuja vuodessa")))
                      ]),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.contract.InvoicingGroup) +
                            " " +
                            _vm._s(_vm.$t("kpl"))
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.contract.ExtraInformation
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            "label-cols-sm": "12",
                            "label-cols-md": "12",
                            "label-cols-lg": "3"
                          }
                        },
                        [
                          _c("label", { staticClass: "pt-0" }, [
                            _vm._v(_vm._s(_vm.$t("Lisätiedot")))
                          ]),
                          _vm._v(" "),
                          _c("b", [
                            _vm._v(_vm._s(_vm.contract.ExtraInformation))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          !_vm.isPriimaPlus()
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("p", [
                          _vm._v(
                            "Kuluttaja-asiakkaalla on oikeus perua sopimus 14 päivän kuluessa sopimuksen tekemisestä (Kuluttajansuojalaki 6 luku 14 §). Jos sähköä käytetään peruutusajan aikana, kuluttaja maksaa käyttämänsä sähkön."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            'Asiakkaanamme Sinulla on käytössäsi jatkuvasti kehittyvät sähköiset palvelumme. Voit valita sähköisen palvelukanavan myös ensijaiseksi palvelukanavaksi antamalla siihen suostumukseksi alla."'
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "dotted" }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _vm.contract.CustomerType ==
                        _vm.CustomerTypeEnum.CONSUMER
                          ? _c("label", { staticClass: "checkbox-inline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.customer.ServiceChannelCode,
                                    expression: "customer.ServiceChannelCode"
                                  },
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  name: "ServiceChannelCode",
                                  "true-value": "sähköposti",
                                  "false-value": ""
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.customer.ServiceChannelCode
                                  )
                                    ? _vm._i(
                                        _vm.customer.ServiceChannelCode,
                                        null
                                      ) > -1
                                    : _vm._q(
                                        _vm.customer.ServiceChannelCode,
                                        "sähköposti"
                                      )
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.customer.ServiceChannelCode,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? "sähköposti" : ""
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.customer,
                                            "ServiceChannelCode",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.customer,
                                            "ServiceChannelCode",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.customer,
                                        "ServiceChannelCode",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                "\n                             Haluan, että minuun ollaan ensisijaisesti yhteydessä sähköisesti\n                        "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contract.CustomerType ==
                        _vm.CustomerTypeEnum.COMPANY
                          ? _c("label", { staticClass: "checkbox-inline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.company.ServiceChannelCode,
                                    expression: "company.ServiceChannelCode"
                                  },
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  name: "ServiceChannelCode",
                                  "true-value": "sähköposti",
                                  "false-value": ""
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.company.ServiceChannelCode
                                  )
                                    ? _vm._i(
                                        _vm.company.ServiceChannelCode,
                                        null
                                      ) > -1
                                    : _vm._q(
                                        _vm.company.ServiceChannelCode,
                                        "sähköposti"
                                      )
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.company.ServiceChannelCode,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? "sähköposti" : ""
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.company,
                                            "ServiceChannelCode",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.company,
                                            "ServiceChannelCode",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.company,
                                        "ServiceChannelCode",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                "\n                             Haluan, että minuun ollaan ensisijaisesti yhteydessä sähköisesti\n                        "
                              )
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Saat halutessasi sähköisesti tietoa myös tarjouksistamme ja tuoteuutuuksistamme. Lähetämme viestejä korkeintaan 1-3 kertaa kuukaudessa ja voit poistua postituslistalta milloin tahansa."
                    )
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "dotted" }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _vm.contract.CustomerType ==
                        _vm.CustomerTypeEnum.CONSUMER
                          ? _c("label", { staticClass: "checkbox-inline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.customer.DirectMarketing,
                                    expression: "customer.DirectMarketing"
                                  },
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  name: "DirectMarketing",
                                  "true-value": "true",
                                  "false-value": "false"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.customer.DirectMarketing
                                  )
                                    ? _vm._i(
                                        _vm.customer.DirectMarketing,
                                        null
                                      ) > -1
                                    : _vm._q(
                                        _vm.customer.DirectMarketing,
                                        "true"
                                      )
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.customer.DirectMarketing,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? "true" : "false"
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.customer,
                                            "DirectMarketing",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.customer,
                                            "DirectMarketing",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.customer,
                                        "DirectMarketing",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                "\n                             Markkinointilupa. Pohjois-Karjalan Sähkö Oy voi lähettää minulle sähköisesti tarjouksia omista tuotteistaan ja palveluistaan\n                        "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contract.CustomerType ==
                        _vm.CustomerTypeEnum.COMPANY
                          ? _c("label", { staticClass: "checkbox-inline" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.company.DirectMarketing,
                                    expression: "company.DirectMarketing"
                                  },
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  name: "DirectMarketing",
                                  "true-value": "true",
                                  "false-value": "false"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.company.DirectMarketing
                                  )
                                    ? _vm._i(
                                        _vm.company.DirectMarketing,
                                        null
                                      ) > -1
                                    : _vm._q(
                                        _vm.company.DirectMarketing,
                                        "true"
                                      )
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.company.DirectMarketing,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? "true" : "false"
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.company,
                                            "DirectMarketing",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.company,
                                            "DirectMarketing",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.company,
                                        "DirectMarketing",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                "\n                             Markkinointilupa. Pohjois-Karjalan Sähkö Oy voi lähettää minulle sähköisesti tarjouksia omista tuotteistaan ja palveluistaan\n                        "
                              )
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("h3", { staticClass: "card-title confirmation-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("Sopimusehdot")))
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "checkbox-inline" },
                  [
                    _c(
                      "validated-form-group",
                      {
                        attrs: {
                          "validation-id": "acceptTerms",
                          "validation-errors": _vm.validationErrors
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "new-contract-value",
                              rawName: "v-new-contract-value"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "acceptTerms",
                            "true-value": "1",
                            "false-value": "0"
                          },
                          domProps: { value: _vm.contract.AcceptTerms }
                        }),
                        _vm._v(
                          "\n                            Olen tutustunut voimassa oleviin "
                        ),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://pks.fi/wp-content/uploads/2019/02/Sahkontoimitusehdot_ste_2014_20160118.pdf",
                              target: "_blank"
                            }
                          },
                          [_vm._v("Sähkönmyyntiehtoihin")]
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _vm.isLoading
                    ? _c("loading-indicator", {
                        staticClass: "loading-indicator"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isLoading,
                          expression: "!isLoading"
                        },
                        {
                          name: "new-contract-validate",
                          rawName: "v-new-contract-validate"
                        }
                      ],
                      staticClass: "text-center",
                      attrs: {
                        method: "post",
                        action: "/NewContract/Contract/Contract"
                      }
                    },
                    [
                      _vm.contract.IsAcceptingOffer &&
                      (_vm.contract.CustomerType ===
                        _vm.CustomerTypeEnum.COMPANY ||
                        !_vm.consumerStrongAuthenticationWhenAcceptingOffer)
                        ? [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-Accept",
                                class: { disabled: _vm.isLoading },
                                staticStyle: {
                                  "margin-bottom": "2px !important"
                                },
                                attrs: { type: "submit" }
                              },
                              [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(" " + _vm._s(_vm.$t("Hyväksy tarjous")))
                              ]
                            )
                          ]
                        : _vm.contract.IsAcceptingOffer &&
                          _vm.contract.CustomerType ===
                            _vm.CustomerTypeEnum.CONSUMER &&
                          _vm.consumerStrongAuthenticationWhenAcceptingOffer
                        ? [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                class: { disabled: _vm.isLoading },
                                staticStyle: {
                                  "margin-bottom": "2px !important"
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.nextPhase()
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(" " + _vm._s(_vm.$t("Hyväksy tarjous")))
                              ]
                            )
                          ]
                        : [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-Accept",
                                class: { disabled: _vm.isLoading },
                                staticStyle: {
                                  "margin-bottom": "2px !important"
                                },
                                attrs: {
                                  type: "submit",
                                  disabled: _vm.isLoading
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(" " + _vm._s(_vm.$t("Hyväksy sopimus")))
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                class: { disabled: _vm.isLoading },
                                staticStyle: {
                                  "margin-bottom": "2px !important"
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.previousPhase()
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-undo" }),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Muokkaa sopimusta"))
                                )
                              ]
                            )
                          ]
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }